module.exports = __webpack_public_path__ + "assets/img/0419.2dd36936.png";